<section class="agpr-adHocCurationReport">
    <!-- What the run looked at, what it kept, and the share of the two. The same card the
         dashboard and Social's engagement column use, laid out with its bar down the side -->
    <div class="agpr-adHocCurationReport-metrics">
        <agpr-card-chart
            [series]="analyzedSeries"
            [color]="cardColors.volume"
            [layout]="cardLayouts.vertical"
            [textAlignLeft]="true"
            [hidePrevious]="true"
            headingLevel="5"
        ></agpr-card-chart>

        <agpr-card-chart
            [series]="curatedSeries"
            [color]="cardColors.impressions"
            [layout]="cardLayouts.vertical"
            [textAlignLeft]="true"
            [hidePrevious]="true"
            headingLevel="5"
        ></agpr-card-chart>

        <agpr-card-chart
            [series]="curationRateSeries"
            [color]="cardColors.engagements"
            [layout]="cardLayouts.vertical"
            [textAlignLeft]="true"
            [isPercentage]="true"
            percentageFormat="1.0-2"
            [hidePrevious]="true"
            headingLevel="5"
        ></agpr-card-chart>
    </div>

    <agpr-panel header="AutomationAgents.adHoc.report.information">
        <div class="agpr-definitionList agpr-adHocCurationReport-information">
            <div class="agpr-definitionList-definitionTitle">
                {{ 'AutomationAgents.agent.summary.createdBy' | localize }}
            </div>
            <div class="agpr-definitionList-definition">
                {{ (createdBy$ | async) ?? ('AutomationAgents.notAvailable' | localize) }}
            </div>

            <div class="agpr-definitionList-definitionTitle">
                {{ 'AutomationAgents.adHoc.report.completionDate' | localize }}
            </div>
            <div class="agpr-definitionList-definition">
                @if (run?.createdAt) {
                    {{ run.createdAt | changeTimeZone: (userTimeZone$ | async) : 'MMMM Do, YYYY h:mm A z' }}
                } @else {
                    {{ 'AutomationAgents.notAvailable' | localize }}
                }
            </div>
        </div>
    </agpr-panel>

    <agpr-panel header="AutomationAgents.adHoc.report.agent">
        <div class="agpr-adHocCurationReport-agent">
            <!-- Opens the agent's own dashboard in a new tab, as the source links do -->
            @if (agentUrl) {
                <a
                    class="agpr-adHocCurationReport-agentName"
                    [href]="agentUrl"
                    target="_blank"
                >{{ agent.name }}</a>
            } @else {
                <span class="agpr-adHocCurationReport-agentName">{{ agent?.name }}</span>
            }

            @if (prompt) {
                <div class="agpr-adHocCurationReport-promptName">{{ prompt.name }}</div>
                <p class="agpr-adHocCurationReport-promptText">{{ prompt.prompt }}</p>
            }

            <!-- What the agent does with a mention it keeps, one chip per action -->
            @if (actions.length) {
                <ul class="agpr-adHocCurationReport-actions">
                    @for (action of actions; track $index) {
                        <li class="agpr-adHocCurationReport-action">
                            <agpr-action-chip
                                [id]="'adHocCurationReport_action_' + $index"
                                [action]="action"
                                (viewActionTarget)="viewActionTarget(action, $event)"
                            ></agpr-action-chip>
                        </li>
                    }
                </ul>
            }
        </div>
    </agpr-panel>

    <agpr-panel header="AutomationAgents.adHoc.report.sources">
        @if (sourceName) {
            <div class="agpr-adHocCurationReport-source">
                <span
                    class="agpr-adHocCurationReport-sourceIcon"
                    [ngClass]="sourceIcon"
                    [pTooltip]="sourceTypeLabel | localize"
                    tooltipPosition="top"
                    [attr.aria-label]="sourceTypeLabel | localize"
                ></span>
                <span class="agpr-adHocCurationReport-sourceName">{{ sourceName }}</span>
                <span class="agpr-adHocCurationReport-sourceType">
                    {{ '(' + (sourceTypeLabel | localize) + ')' }}
                </span>
            </div>
        } @else {
            <agpr-message
                id="adHocCurationReport.noSource"
                [severity]="messageSeverity.noContent"
                [bottomMargin]="false"
                [useWhiteBg]="true"
            >
                {{ 'AutomationAgents.adHoc.report.noSource' | localize }}
            </agpr-message>
        }
    </agpr-panel>
</section>
